import React from 'react';
import Image, { StaticImageData } from 'next/image';
import { getSrc } from '~app/helpers/assetLoading';

type ImageProps = {
  src: string | StaticImageData;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  sizes?: string;
  priority?: boolean;
  quality?: number;
  fill?: boolean;
  'data-testid'?: string;
  onError?: () => void;
  onLoad?: () => void;
};

const EPImage = ({
  src,
  alt,
  width,
  height,
  className,
  sizes,
  priority = false,
  quality = 75,
  fill = false,
  'data-testid': testId,
  onError,
  onLoad,
  ...props
}: ImageProps): JSX.Element => {
  // Get the source URL and handle protocol-relative URLs
  const imageSrc = getSrc(src);
  const normalizedSrc = typeof imageSrc === 'string' && imageSrc.startsWith('//') ? `https:${imageSrc}` : imageSrc;

  const imageProps = {
    src: normalizedSrc,
    alt,
    className,
    priority,
    quality,
    'data-testid': testId,
    width: fill ? undefined : width ?? 100,
    height: fill ? undefined : height ?? 100,
    ...(sizes && { sizes }),
    ...(onError && { onError }),
    ...(onLoad && { onLoad }),
    ...(fill && { fill }),
    ...props,
  };

  return (
    <Image
      overrideSrc={getSrc(normalizedSrc)}
      {...imageProps}
      style={{
        objectFit: fill ? 'cover' : 'contain',
        objectPosition: 'center',
      }}
    />
  );
};

export default EPImage;
